(function () {
  "use strict";

  const $ = (id) => document.getElementById(id);
  const container = document.getElementById("room-visualizer");
  if (!container) return;

  const fileInput = $("rv-file-input");
  if (!fileInput) return; // Exit if elements are not rendered (e.g. for guest users)

  const API_URL = container.dataset.apiUrl;
  const isProductPage = container.dataset.isProductPage === "true";

  // ── State ────────────────────────────────────────────────────────────────
  let roomImageDataUrl = null;
  let selectedProduct = null; // { title, imageUrl }
  let placementMode = null;   // "replace" or "add"

  // ── Upload ───────────────────────────────────────────────────────────────
  const uploadZone = $("rv-upload-zone");
  const previewWrap = $("rv-preview-wrap");
  const previewImg = $("rv-preview-img");
  const changeBtn = $("rv-change-btn");
  const productStep = $("rv-product-step");

  // Show only cards that have a valid product image (metafield set)
  const allCards = container.querySelectorAll(".rv-product-card");
  let visibleCount = 0;
  allCards.forEach((card) => {
    const img = card.dataset.productImage;
    if (img && img.length > 10 && !img.includes("// ")) {
      card.style.display = "";
      visibleCount++;
    }
  });
  const noProductsMsg = $("rv-no-products");
  if (noProductsMsg && visibleCount === 0) noProductsMsg.style.display = "";

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = () => reject(new Error("Could not read file"));
      reader.readAsDataURL(file);
    });
  }

  function resizeDataUrl(dataUrl, maxPx = 1200) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxPx / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.src = dataUrl;
    });
  }

  async function handleFile(file) {
    if (!file || !file.type.startsWith("image/")) return;
    if (file.size > 10 * 1024 * 1024) { showError("התמונה חייבת להיות קטנה מ-10MB"); return; }
    let dataUrl = await fileToDataUrl(file);
    dataUrl = await resizeDataUrl(dataUrl, 1200);
    roomImageDataUrl = dataUrl;
    previewImg.src = dataUrl;
    uploadZone.style.display = "none";
    previewWrap.style.display = "";
    if (isProductPage) {
      placementStep.style.display = "";
      placementStep.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } else {
      productStep.style.display = "";
    }
  }

  // Camera button
  const cameraInput = document.getElementById("rv-camera-input");
  const cameraBtn = document.getElementById("rv-camera-btn");
  const uploadBtn = document.getElementById("rv-upload-btn");

  if (cameraBtn) cameraBtn.addEventListener("click", () => cameraInput && cameraInput.click());
  if (uploadBtn) uploadBtn.addEventListener("click", () => fileInput && fileInput.click());
  if (cameraInput) cameraInput.addEventListener("change", (e) => { if (e.target.files[0]) handleFile(e.target.files[0]); });

  fileInput.addEventListener("change", (e) => { if (e.target.files[0]) handleFile(e.target.files[0]); });
  uploadZone.addEventListener("dragover", (e) => { e.preventDefault(); uploadZone.classList.add("drag-over"); });
  uploadZone.addEventListener("dragleave", () => uploadZone.classList.remove("drag-over"));
  uploadZone.addEventListener("drop", (e) => {
    e.preventDefault();
    uploadZone.classList.remove("drag-over");
    if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
  });

  changeBtn.addEventListener("click", () => {
    roomImageDataUrl = null;
    previewImg.src = "";
    uploadZone.style.display = "";
    previewWrap.style.display = "none";
    productStep.style.display = "none";
    $("rv-placement-step").style.display = "none";
    fileInput.value = "";
    if ($("rv-replace-item")) $("rv-replace-item").value = "";
    selectedProduct = null;
    placementMode = null;
    autoSelectProductIfProductPage();
  });

  // ── Product selection ────────────────────────────────────────────────────
  const placementStep = $("rv-placement-step");

  function selectProduct(card) {
    container.querySelectorAll(".rv-product-card").forEach((c) => c.classList.remove("selected"));
    card.classList.add("selected");
    selectedProduct = {
      title: card.dataset.productTitle,
      imageUrl: card.dataset.productImage,
      handle: card.dataset.productHandle,
      variantId: card.dataset.productVariant || "",
      height: card.dataset.productHeight || "",
      width: card.dataset.productWidth || "",
      depth: card.dataset.productDepth || ""
    };
  }

  function autoSelectProductIfProductPage() {
    if (isProductPage) {
      const activeCard = container.querySelector(".rv-product-card");
      if (activeCard) {
        selectProduct(activeCard);
      }
    }
  }

  // Auto select active product on initialization
  autoSelectProductIfProductPage();

  container.querySelectorAll(".rv-product-card").forEach((card) => {
    card.addEventListener("click", () => {
      selectProduct(card);
      placementStep.style.display = "";
      placementStep.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  });

  // ── Placement mode ───────────────────────────────────────────────────────
  const replaceInput = $("rv-replace-input");
  const replaceLabel = replaceInput.querySelector(".rv-label");
  const replaceInputField = $("rv-replace-item");
  const visualizeBtn = $("rv-visualize-btn");

  [$("rv-mode-replace"), $("rv-mode-add")].forEach((btn) => {
    btn.addEventListener("click", () => {
      [$("rv-mode-replace"), $("rv-mode-add")].forEach((b) => b.classList.remove("selected"));
      btn.classList.add("selected");
      placementMode = btn.dataset.mode;
      
      // Always show the instruction input
      replaceInput.style.display = "";
      
      if (placementMode === "replace") {
        if (replaceLabel) replaceLabel.textContent = "מה תרצו להחליף?";
        if (replaceInputField) replaceInputField.placeholder = "למשל: הספרייה הישנה, הכורסא, המזנון...";
      } else {
        if (replaceLabel) replaceLabel.textContent = "הנחיות נוספות או מיקום מיוחד (אופציונלי):";
        if (replaceInputField) replaceInputField.placeholder = "למשל: להוסיף 2 יחידות צמודות, למקם ליד החלון...";
      }
      
      visualizeBtn.style.display = "";
    });
  });

  // ── Visualize ────────────────────────────────────────────────────────────
  visualizeBtn.addEventListener("click", async () => {
    if (!roomImageDataUrl) { showError("אנא העלו תמונה של החדר"); return; }
    if (!selectedProduct) { showError("אנא בחרו מוצר"); return; }
    if (!placementMode) { showError("אנא בחרו אופן מיקום"); return; }

    const replaceItem = $("rv-replace-item") ? $("rv-replace-item").value.trim() : "";
    if (placementMode === "replace" && !replaceItem) {
      $("rv-replace-item").focus();
      $("rv-replace-item").style.borderColor = "#c00";
      setTimeout(() => ($("rv-replace-item").style.borderColor = ""), 1500);
      return;
    }

    showStep("rv-step-loading");

    try {
      // Fetch product image as base64
      let productImageDataUrl = null;
      const res = await fetch(selectedProduct.imageUrl);
      const blob = await res.blob();
      productImageDataUrl = await fileToDataUrl(blob);
      productImageDataUrl = await resizeDataUrl(productImageDataUrl, 800);

      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          room_image: roomImageDataUrl,
          product_image: productImageDataUrl,
          product_name: selectedProduct.title,
          placement_mode: placementMode,
          replace_item: replaceItem,
          product_height: selectedProduct.height,
          product_width: selectedProduct.width,
          product_depth: selectedProduct.depth
        })
      });

      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.error || "שגיאה לא ידועה");

      $("rv-result-before").src = roomImageDataUrl;
      $("rv-result-after").src = data.image_url;

      const productLink = $("rv-product-link");
      if (productLink && selectedProduct.handle) {
        productLink.href = "/products/" + selectedProduct.handle;
      }

      showStep("rv-step-result");

    } catch (err) {
      showStep("rv-step-1");
      showError(err.message || "משהו השתבש, אנא נסו שוב");
    }
  });

  // ── Result actions ───────────────────────────────────────────────────────
  $("rv-restart-btn").addEventListener("click", () => {
    roomImageDataUrl = null;
    selectedProduct = null;
    placementMode = null;
    previewImg.src = "";
    previewWrap.style.display = "none";
    uploadZone.style.display = "";
    productStep.style.display = "none";
    placementStep.style.display = "none";
    $("rv-replace-input").style.display = "none";
    visualizeBtn.style.display = "none";
    [$("rv-mode-replace"), $("rv-mode-add")].forEach((b) => b.classList.remove("selected"));
    container.querySelectorAll(".rv-product-card").forEach((c) => c.classList.remove("selected"));
    fileInput.value = "";
    if ($("rv-replace-item")) $("rv-replace-item").value = "";
    autoSelectProductIfProductPage();
    showStep("rv-step-1");
  });

  $("rv-error-retry").addEventListener("click", () => {
    $("rv-error").style.display = "none";
    showStep("rv-step-1");
  });

  // ── Helpers ──────────────────────────────────────────────────────────────
  function showStep(stepId) {
    ["rv-step-1", "rv-step-loading", "rv-step-result", "rv-error"].forEach((id) => {
      const el = $(id);
      if (el) el.style.display = id === stepId ? "" : "none";
    });
  }

  function showError(msg) {
    $("rv-error-msg").textContent = msg;
    $("rv-error").style.display = "";
    $("rv-step-loading").style.display = "none";
  }

  // ── Cart Integration ──────────────────────────────────────────────────────
  const addToCartBtn = $("rv-add-to-cart-btn");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", async () => {
      if (!selectedProduct || !selectedProduct.variantId) return;
      addToCartBtn.textContent = "מוסיף לסל...";
      addToCartBtn.disabled = true;
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: selectedProduct.variantId, quantity: 1 }),
        });
        if (res.ok) {
          addToCartBtn.textContent = "נוסף לסל! ✓";
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          setTimeout(() => {
            addToCartBtn.textContent = "הוספה לסל";
            addToCartBtn.disabled = false;
          }, 3000);
        } else {
          throw new Error("Add failed");
        }
      } catch (err) {
        addToCartBtn.textContent = "שגיאה בהוספה";
        addToCartBtn.disabled = false;
        setTimeout(() => {
          addToCartBtn.textContent = "הוספה לסל";
        }, 3000);
      }
    });
  }

  // ── Lightbox Modal ────────────────────────────────────────────────────────
  const lightbox = $("rv-lightbox");
  const lightboxImg = $("rv-lightbox-img");
  const lightboxClose = $("rv-lightbox-close");
  const resultBefore = $("rv-result-before");
  const resultAfter = $("rv-result-after");

  function openLightbox(src) {
    if (lightbox && lightboxImg) {
      lightboxImg.src = src;
      lightbox.style.display = "flex";
    }
  }

  function closeLightbox() {
    if (lightbox) {
      lightbox.style.display = "none";
      if (lightboxImg) lightboxImg.src = "";
    }
  }

  if (resultBefore) {
    resultBefore.addEventListener("click", () => openLightbox(resultBefore.src));
  }
  if (resultAfter) {
    resultAfter.addEventListener("click", () => openLightbox(resultAfter.src));
  }
  if (lightbox) {
    lightbox.addEventListener("click", (e) => {
      if (e.target !== lightboxImg) {
        closeLightbox();
      }
    });
  }
  if (lightboxClose) {
    lightboxClose.addEventListener("click", closeLightbox);
  }
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeLightbox();
  });

})();
